<div class="wrapperStyle">
  <div id="main-wrapper">
    <ngx-loading [show]="showSpinner" [config]="{ backdropBorderRadius: '14px' }"></ngx-loading>
    <app-header (found)="handleResults($event)"></app-header>

    <div class=" tab inner-tab-container dashboardContainer  main-background topSpace main-container">
      <app-search-results [resultGridList]="data"></app-search-results>
      <!-- Nav tabs -->
      <h1 class="carelon-page-title ">Performance Dashboard</h1>
      <div class="dashboard-content">
        <div class="tab-pane dashboard-pane">
          <div class="row">
            <div class="row col-md-12">
              <h3 style ="margin-top:0px" class="title noTransform">Select a site and Primary Care Physician to view the performance dashboard <i
              class="fa fa-question-circle"></i>
            </h3>
          </div>
          @if (showView) {
            <div class="dashboard-view" [class.div_height] = "showNoRecords == true" [ngClass] = "{'div_height':!(showTabs && diseasesList.length)}">
              <div class="col-md-12 row position-align-end">
                <div
                  class="form-group col-md-4 col-xs-12 cup-dd-down-arrow cup-dd-down-arrow-search cup-dd-down-screen-basis row">
                  <!-- [ngClass]="{'invalid': eligRequestErrorHealthPlan}" -->
                  <label for="memberHealthPlan"><span class="required"><sub>*</sub></span><span class="measure-label"> SITE</span></label>
                  <cup-autocomplete class="input-underline" [colWidth]="16" [(ngModel)]="selectedSite" [autoCompleteModel]="selectedSite"
                    [autoCompleteDynamic]="true" [autoCompleteOptions]="sites" (autoCompleteModelChange)="setProviders($event)"
                  emptyMessage='No Sites Found' [autoCompletePlaceholder]="'Select Site'"></cup-autocomplete>
                  <!-- <span class="errorMsg" *ngIf="eligRequestErrorHealthPlan"> Field cannot be left blank </span> -->
                </div>
                <div
                  class="form-group col-md-4 col-xs-12 cup-dd-down-arrow cup-dd-down-arrow-search cup-dd-down-screen-basis"
                  style="position: relative;">
                  <!-- [ngClass]="{'invalid': eligRequestErrorHealthPlan}" -->
                  <div >
                    <label for="provider"><span class="required"><sub>*</sub></span><span class="measure-label">PRIMARY CARE PHYSICIANS</span> </label>
                    <cup-autocomplete class="input-underline" [colWidth]="16" [autoCompleteModel]="selectedProviderModel"
                      emptyMessage='No Providers Found' [autoCompleteDynamic]="true" [autoCompleteOptions]="providers"
                      (autoCompleteModelChange)="onProvidersSubmit($event)" [autoCompletePlaceholder]="'Select PRIMARY CARE PHYSICIANS'">
                    </cup-autocomplete>
                  </div>
                </div>
                <div class="form-group col-md-4 col-xs-12 hedisReportBtnGroup">
                  <button class="carelon-btn hedisReportBtn" (click)="openMultiSelectHedisDialog()">Consolidated Hedis Report</button>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12" >
                  <!-- <div class="search-icon-sec" style="left:98%;" (click)="$event.stopPropagation()" *ngIf="!isInternalUser">
                  <i (click)="openPopup()" aria-hidden="true" class="fa fa-search-plus" style="color:#23499E;"></i>
                </div> -->
                <!-- <span class="errorMsg" *ngIf="eligRequestErrorHealthPlan"> Field cannot be left blank </span> -->
                @if (providerAffiliationList && providerAffiliationList.length > 0) {
                  <div class="col-md-4 providerAff">
                    <div class="form-group provider-affiliated-list-view m-t-20">
                      <label class="provider-aff-label"> Provider Affiliation </label>
                      <div class="inner-list-view">
                        <ul class="p-0">
                          @for (provider of providerAffiliationList; track provider) {
                            <li>
                              <span class="provider-aff-detail" href="javascript:void(0)">{{ provider.name }}</span>
                            </li>
                          }
                        </ul>
                      </div>
                    </div>
                  </div>
                }
              </div>
              @if (showNoRecords) {
                <div class="form-group col-md-4 col-xs-12 alert">
                  No Quality Measures found.
                </div>
              }
            </div>
          </div>
        }
        

        <div class="clearfix"></div>

        
        @if (showTabs && diseasesList.length) {
          <div class="row col-md-12 custom-tabs dashboardView qmcustom-tabs">
            <h3 class="heading">Search Results</h3>
            <button class="reportBtn carelon-btn" (click)="showDialog = !showDialog">Generate HEDIS Report</button>
           
            <p-tabs [(value)]="tabValue">
              <p-tablist>
                  @for (tab of items; track tab.label) {
                      <p-tab [value]="tab.label"><span [ngClass] = "tab.icon" ></span>{{ tab.label }}</p-tab>
                  }
              </p-tablist>
              <p-tabpanels>
                <p-tabpanel [value]="items[0].label">
                  <div>
                    <p class="italicText">Note: The list includes Active Patients only.</p>
                    <div class="common-collapse-expand ">
                      @if (showCollapseAll) {
                        <span class="common-collapse-expand-span" (click)="expandAllPanels()">
                          <span class="italicText">Collapse All </span>
                          <i class="fa fa-chevron-circle-down" aria-hidden="true"></i>
                        </span>
                      }
                      @if (!showCollapseAll) {
                        <span class="common-collapse-expand-span" (click)="expandAllPanels()">
                          <span class="italicText">Expand All </span>
                          <i class="fa fa-chevron-circle-right" aria-hidden="true"></i>
                        </span>
                      }
                    </div>
                    <!-- [activeIndex]="index" -->
                    <p-accordion [multiple]="true" [(value)]="accordionActiveIndex"
                      (onOpen)="accordionTabOpened(panelIndex)" (onClose)="accordionTabClosed(panelIndex)">
                      @for (disease of diseasesList; track disease; let rowIndex = $index) {
                        <p-accordion-panel class="color-r"
                        [value]="rowIndex"
                          [(selected)]="activeTabs[rowIndex]" (click)="onMeasureSelect(disease)">
                          <p-accordion-header style="flex: 0 0.9 100%; ">
                            <div style = " display: flex;
                              flex-flow: row;">
                              @if (disease.pcpIncentive) {
                                <div title = "2026 PCP Quality Incentive Program" class="pcp_incentive"></div>
                              }</div>
                              <div class="acc-header" [ngClass]="'dynamicStyleClass' + rowIndex">
                                <div class="acc-content-label"> {{disease?.measure}}</div>
                                <!-- <div class="acc-content-star">
                                <ng-container *ngIf="disease?.starRating != -1">
                                  <star-rating [value]="disease?.starRating"> </star-rating>
                                </ng-container>
                              </div> -->
                            </div>
                          </p-accordion-header>
                          <!-- <p-accordion [multiple]="true" [activeIndex]="accordionActiveIndex"
                          (onOpen)="accordionTabOpened(panelIndex)" (onClose)="accordionTabClosed(panelIndex)">
                          <p-accordionTab class="row" [selected]="true"> -->
                            <p-accordion-content>

                            
                            <div>
                              <!-- <div class="accordion-info border borderBtm0">
                              <div class="info-sec">
                                <label> Eligible Patients:</label>
                                <label class="label-value">{{disease?.denominator}}</label>
                              </div>
                              <div class="info-sec">
                                <label> Non-Compliant Patients:</label>
                                <label class="label-value">{{disease?.notMet}}</label>
                              </div>
                              <div class="info-sec">
                                <label>
                                Rate Completed (%):</label>
                                <label class="label-value">{{disease?.metPercentage}}%</label>
                              </div>
                              <div class="info-sec">
                                <label>Target Goal (5 Star) :</label>
                                <label class="label-value">{{disease?.targetGoal}}</label>
                              </div>
                            </div> -->
                            <div class="border shadow borderTop0">
                              <div>
                                <div class="accordion-info fixed-height table-scroll iefixedTableHeader">
                                  <table class="table custom-table fixed-height table-scroll fixedLayout">
                                    <thead></thead>
                                    <tbody>
                                      <tr class="no-color-header table-header">
                                        <td class="no-color-header" style="width: 12em">Member Name</td>
                                        <td class="no-color-header" style="width: 10em">Date of Birth</td>
                                        <td class="no-color-header" style="width: 5em">Age</td>
                                        <td class="no-color-header" style="width: 6em">Event Date</td>
                                        <td class="no-color-header" style="width: 6em">Event Value</td>
                                        <td class="no-color-header" style="width: 8em">Status</td>
                                        <td class="no-color-header" style="width: 8em">Event Notes</td>
                                        <td class="no-color-header" style="width: 14.2em">Exclusion Notes
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                                <div class="accordion-info fixed-height table-scroll ieFix border m-2">
                                  <table class="table custom-table fixed-height table-scroll fixedLayout mb-4">
                                    <thead>
                                      <tr class="no-color-header table-header border">
                                        <th class="no-color-header" style="width: 12em">Member Name</th>
                                        <th class="no-color-header" style="width: 10em">Date of Birth</th>
                                        <th class="no-color-header" style="width: 5em">Age</th>
                                        <th class="no-color-header" style="width: 6em">Event Date</th>
                                        <th class="no-color-header" style="width: 6em">Event Value</th>
                                        <th class="no-color-header" style="width: 8em">Status</th>
                                        <th class="no-color-header" style="width: 8em">Event Notes</th>
                                        <th class="no-color-header" style="width: 8em">Exclusion Notes
                                        </th>
                                        <th class="no-color-header" style="width: 9.2em;text-align: center; ">Medical Records</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      @for (member of membersList[disease.measureId]?.list || [] | memberFilterArray ; track member; let i = $index) {
                                        <tr class="border"
                                          >
                                          <td style="width: 12em" [ngClass]="{'rowBgchanged':i ==indexOfClickedRow && selectedMemberId==member.memberId}"  (click)="template1(member)">
                                            {{member?.membername}}
                                          </td>
                                          <td style="width: 10em" [ngClass]="{'rowBgchanged':i ==indexOfClickedRow && selectedMemberId==member.memberId}"  (click)="template1(member)">{{member?.dob | customDateFilter}}</td>
                                          <td style="width: 5em" [ngClass]="{'rowBgchanged':i ==indexOfClickedRow && selectedMemberId==member.memberId}"  (click)="template1(member)">{{member?.age}}</td>
                                          <td style="width: 6em"  [ngClass]="{'rowBgchanged':i ==indexOfClickedRow && selectedMemberId==member.memberId}" (click)="template1(member)">{{member?.eventdate | customDateFilter}}</td>
                                          <td style="width: 6em" [ngClass]="{'rowBgchanged':i ==indexOfClickedRow && selectedMemberId==member.memberId}"  (click)="template1(member)">{{member?.eventvalue}}</td>
                                          <td style="width: 8em"  [ngClass]="{'rowBgchanged':i ==indexOfClickedRow && selectedMemberId==member.memberId}" (click)="template1(member)"
                                            [ngClass]="member?.status == 'NOT MET'? 'notmet-color' : 'met-color'">
                                          {{member?.status}}</td>
                                          <td style="width: 8em" [ngClass]="{'rowBgchanged':i ==indexOfClickedRow && selectedMemberId==member.memberId}"  (click)="template1(member)">{{member?.statusDesc}}</td>
                                          <td  (click)="template1(member)" [ngClass]="{'rowBgchanged':i ==indexOfClickedRow && selectedMemberId==member.memberId}"
                                            [ngStyle]="{'width': membersList[disease.measureId]?.list.length > 6 ? '14.2em' : '15em' }">
                                          {{member?.exclusionNote}}</td>
                                          <td [ngClass]="{'rowBgchanged':i ==indexOfClickedRow && selectedMemberId==member.memberId}">
                                            <div class="documentUploadIcon">
                                              <span class="documentIcon"  [ngClass]="{'ifUploadIconHide': member?.status === 'MET'}">
                                                <img src="assets/images/DocumentIcon.svg"  [ngClass]="{'disabled-img': i == indexOfClickedRow  && selectedMemberId==member.memberId}"   title="Documents" class="logo-docsPdf"   (click)=" showDoc(i,member,'member')"/>
                                              </span>
                                              @if (member?.status!='MET' && medDocUploadFlaglist[disease.measureId] == true) {
                                                <img src="assets/images/upload-docs.svg" class="logo-upload"  title="Upload Document"  (click)="uploadQmeasureMedicalDoc(rowIndex,member,'member')"  />
                                              }
                                            </div>
                                          </td>
                                        </tr>
                                        @if (i ==indexOfClickedRow && selectedMemberId==member.memberId) {
                                          <tr>
                                            <td colspan="9">
                                              <div class="uploadedDoc-section">
                                                <p class="DocumentHeading-section">
                                                  <span>
                                                    Submitted Medical Record Documents
                                                  </span>
                                                  <img src="assets/images/icon_close copy.svg"  title="close" class="close-icon"   (click)=" closeRow()"/>
                                                  <!-- <button class="close-btn" (click)="closeRow()">X</button> -->
                                                </p>
                                                <div class="table-body">
                                                  <table style="width: 100% ;border: 1px solid #D1D1D1;">
                                                    <thead>
                                                      <tr>
                                                        <th>Document Name</th>
                                                        <th>Document Type</th>
                                                        <th>Uploaded By</th>
                                                        <th>Uploaded Date</th>
                                                        <th>Status</th>
                                                        <th style="width:25%">Actions</th>
                                                      </tr>
                                                    </thead>
                                                    <tbody>
                                                      @if (qmUploadedDoc.length === 0) {
                                                        <tr>
                                                          <td colspan="5" style="text-align: center;">
                                                            No document available
                                                          </td>
                                                        </tr>
                                                      }
                                                      @for (each of qmUploadedDoc; track each) {
                                                        <tr style="border: 1px solid #D1D1D1;">
                                                          <td>
                                                            <span>
                                                              <img src="assets/images/DocumentIcon.svg"  title="pdf-icon" class="pdfTypeIcon"/>
                                                            </span>
                                                            {{each.DocumentTitle}}
                                                          </td>
                                                          <td>
                                                            {{each.type}}
                                                          </td>
                                                          <td>{{each.PPUserName}} ({{each.CreatedUser}})</td>
                                                          <td>
                                                            {{each.UpdatedDate}}
                                                          </td>
                                                          <td>
                                                            @if (member?.status=='NOT MET') {
                                                              <button class="inProgressBtn">
                                                                Uploaded
                                                              </button>
                                                              } <br>
                                                              @if (each?.status=='Rejected') {
                                                                <button class="declinnedBtn">
                                                                  Rejected
                                                                </button>
                                                              }
                                                              @if (member?.status=='MET') {
                                                                <button class="approvedBtn">
                                                                  Uploaded
                                                                </button>
                                                              }
                                                            </td>
                                                            <td>
                                                              <img src="assets/images/View-Icon.svg"  title="Preview" class="logo-preview" (click)="onViewDocument(each)"/>
                                                              <img src="assets/images/DownloadDocs-Icon.svg"  title="Download" (click)="getDocument(each)" class="logo-download"/>
                                                              <img src="assets/images/Delete-Icon.svg" title="Delete" (click)="showDeleteModel(each)" class="logo-delete"/>
                                                            </td>
                                                          </tr>
                                                        }
                                                      </tbody>
                                                    </table>
                                                  </div>
                                                </div>
                                              </td>
                                            </tr>
                                          }
                                        }
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </p-accordion-content>
                          <!-- </p-accordionTab>
                        </p-accordion> -->
                      </p-accordion-panel>
                    }
                  </p-accordion>
                </div>
                </p-tabpanel>
                <p-tabpanel [value]="items[2].label">
                  <div>
                    <br>
                      <div class="row no-gutter">
                        <div class="col-md-4">
                          <div class="select-measure-label"><span class="required"><sub>*</sub></span>Select Measure</div>
                          <select class="form-select col-md-12 lineHeight measure-dropdown" [(ngModel)] = "selectedDisease" (change)="onQmDashboardChange($event)">
                            <option value = "" disabled>Select</option>
                            @for (disease of diseasesList; track disease) {
                              <option [value]="disease.measureId">{{disease.measure}}</option>
                            }
                          </select>
                        </div>
                        <div class="col-md-2"></div>
                        <div class="col-md-3">
                          <div class="select-measure-label"><span class="required"><sub>*</sub></span>Select Contract</div>
                          <select [disabled]="disableDropDown" class="form-select col-md-12 lineHeight measure-dropdown" [(ngModel)] = "selectSegmentName" (change)="onSegmentChange($event)">
                            <option value = "" disabled>Select</option>
                            @for (disease of contractName; track disease) {
                              <option [value]="disease">{{disease}}</option>
                            }
                          </select>
                          @if (selectedDisease != '' && selectSegmentName == '' && disableDropDown) {
                            <div class="contractName">
                              <!-- No Data Available-->
                              No Data Available for this measure
                            </div>
                          }
                        </div>
                      </div>
                      <br>
                        @if (selectSegmentName != '' && !disableDropDown) {
                          <div>
                            <div class="row no-gutter m-t-20">
                              <div class="col-md-3 measure-heading1">
                                <span class="fa fa-users measure-heading"></span>&nbsp;&nbsp;Members Open
                              </div>
                              <div class="col-md-1">
                              </div>
                              <div class="col-md-8 measure-heading1">
                                <span class="fa fa-users measure-heading"></span>&nbsp;&nbsp;Members to Close
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-3 memberOpenBox ">
                                <div class="row">
                                  <div class="col-md-5 member-open-number carelon-semibold" style="display:flex;align-self: center;">{{memberCount}}</div>
                                  <div class="col-md-7 mt-2">
                                    <div >
                                      <div class="carelon-regular" style="font-size: 17px;">Members Open</div>
                                      <div class="carelon-regular" style="font-size: 16px;">as of <span class="carelon-semibold">{{SegmentNameDetails[1] ? SegmentNameDetails[1] : ''}}</span></div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-1"></div>
                              <div class="col-md-8">
                                <div class="row">
                                  <div class="col-md-3" style="color:#333333;font-size:12px">
                                    <div class="carelon-regular">For<span class="carelon-semibold" style="font-size: 18px;font-weight: bold;"> "3 star"</span></div>
                                    <div>
                                      <span class="fa fa-solid fa-star" style="color:#F8ad43;font-size:16px"></span>
                                      <span class="fa fa-solid fa-star" style="color:#F8ad43;font-size:16px"></span>
                                      <span class="fa fa-solid fa-star" style="color:#F8ad43;font-size:16px"></span>
                                    </div>
                                    <div class="row m-t-20" style="display:flex;align-items: center;padding:0px">
                                      <div class="col-md-3 carelon-regular"><a class="carelon-regular" href="javascript:void(0)" (click)="clickMe(newQmDBStatusList ? newQmDBStatusList[0].measureId : '')" style="padding:0px;font-weight:bold;font-size:24px; text-decoration: none;">{{SegmentNameDetails[0] ? SegmentNameDetails[0].numeratorLeftTo3star : '0'}}</a></div>
                                      <div class="col-md-8 carelon-regular">Members to close</div>
                                    </div>
                                  </div>
                                  <div class="col-md-3" style="color:#333333;font-size:12px">
                                    <div class="carelon-regular">For<span  class="carelon-semibold" style="font-size: 18px;font-weight: bold;"> "4 star"</span></div>
                                    <div>
                                      <span class="fa fa-solid fa-star" style="color:#F8ad43;font-size:16px"></span>
                                      <span class="fa fa-solid fa-star" style="color:#F8ad43;font-size:16px"></span>
                                      <span class="fa fa-solid fa-star" style="color:#F8ad43;font-size:16px"></span>
                                      <span class="fa fa-solid fa-star" style="color:#F8ad43;font-size:16px"></span>
                                    </div>
                                    <div class="row m-t-20" style="display:flex;align-items: center;padding:0px">
                                      <div class="col-md-3 carelon-regular"><a class="carelon-regular" style="padding:0px;font-weight:bold;font-size:24px; text-decoration: none;" href="javascript:void(0)" (click)="clickMe(newQmDBStatusList ? newQmDBStatusList[0].measureId : '')">{{SegmentNameDetails[0] ? SegmentNameDetails[0].numeratorLeftTo4star : '0'}}</a></div>
                                      <div class="col-md-8 carelon-regular">Members to close</div>
                                    </div>
                                  </div>
                                  <div class="col-md-3" style="color:#333333;font-size:12px">
                                    <div class="carelon-regular">For<span  class="carelon-semibold" style="font-size: 18px;font-weight: bold;"> "5 star"</span></div>
                                    <div>
                                      <span class="fa fa-solid fa-star" style="color:#F8ad43;font-size:16px"></span>
                                      <span class="fa fa-solid fa-star" style="color:#F8ad43;font-size:16px"></span>
                                      <span class="fa fa-solid fa-star" style="color:#F8ad43;font-size:16px"></span>
                                      <span class="fa fa-solid fa-star" style="color:#F8ad43;font-size:16px"></span>
                                      <span class="fa fa-solid fa-star" style="color:#F8ad43;font-size:16px"></span>
                                    </div>
                                    <div class="row m-t-20" style="display:flex;align-items: center;padding:0px">
                                      <div class="col-md-3 carelon-regular"><a class="carelon-regular" style="padding:0px;font-weight:bold;font-size:24px;text-decoration: none;" href="javascript:void(0)" (click)="clickMe(newQmDBStatusList ? newQmDBStatusList[0].measureId : '')">{{SegmentNameDetails[0] ? SegmentNameDetails[0].numeratorLeftTo5star : '0'}}</a></div>
                                      <div class="col-md-8 carelon-regular">Members to close</div>
                                    </div>
                                  </div>
                                  <div class="col-md-3"></div>
                                </div>
                              </div>
                            </div>
                            <div class="row no-gutter m-t-20">
                              <div class="col-md-3 measure-heading1">
                                <span class="fa fa-star-o measure-heading" ></span> Rating
                              </div>
                            </div>
                            <div class="row no-gutter m-t-20">
                              <div class="col-md-2 " style="border:1px solid #E5E5E5;padding:0px;margin:10px">
                                <div class="current-star-rating">
                                  Current Star Rating
                                </div>
                                <div class="col-md-12 m-t-10 m-b-10" style="display:flex;align-items: center;padding:0px 0px 0px 20px">
                                  <span class="carelon-semibold" style="padding:0px;font-weight:bold;font-size:18px;">{{SegmentNameDetails[0] ? SegmentNameDetails[0].combinedStar : '0'}} </span>
                                  <span class ="carelon-regular" style="font-size:15px;">&nbsp;Star</span>
                                </div>
                                <div class="m-b-10" style = "padding:0px 0px 0px 20px;font-size: 12px;">
                                  @for (i of combinedStar; track i) {
                                    <span class="fa fa-solid fa-star" style="color:#F8ad43;font-size: 16px;"></span>
                                  }
                                </div>
                              </div>
                              <!-- <div class="col-md-2 " style="border:1px solid #E5E5E5;padding:0px;margin:10px">
                              <div style="background-color:#23499E;color:#ffffff;padding:5px;">
                                Prior Week Star Rating
                              </div>
                              <div class="col-md-12 m-t-10 m-b-10" style="display:flex;align-items: center;padding:0px 0px 0px 20px">
                                <span style="padding:0px;font-weight:bold;font-size:18px;">5 </span>
                                <span>Star</span>
                              </div>
                              <div class="m-b-10" style = "padding:0px 0px 0px 20px;">
                                <span class="fa fa-solid fa-star" style="color:#F8ad43"></span>
                                <span class="fa fa-solid fa-star" style="color:#F8ad43"></span>
                                <span class="fa fa-solid fa-star" style="color:#F8ad43"></span>
                                <span class="fa fa-solid fa-star" style="color:#F8ad43"></span>
                                <span class="fa fa-solid fa-star" style="color:#F8ad43"></span>
                              </div>
                            </div>
                            <div class="col-md-2 " style="border:1px solid #E5E5E5;padding:0px;margin:10px">
                              <div style="background-color:#23499E;color:#ffffff;padding:5px;">
                                Prior Year Star Rating
                              </div>
                              <div class="col-md-12 m-t-10 m-b-10" style="display:flex;align-items: center;padding:0px 0px 0px 20px">
                                <span style="padding:0px;font-weight:bold;font-size:18px;">4 </span>
                                <span>Star</span>
                              </div>
                              <div class="m-b-10" style = "padding:0px 0px 0px 20px;">
                                <span class="fa fa-solid fa-star" style="color:#F8ad43"></span>
                                <span class="fa fa-solid fa-star" style="color:#F8ad43"></span>
                                <span class="fa fa-solid fa-star" style="color:#F8ad43"></span>
                                <span class="fa fa-solid fa-star" style="color:#F8ad43"></span>
                                <span class="fa fa-solid fa-star-o" style="color:#F8ad43"></span>
                              </div>
                            </div> -->
                          </div>
                        </div>
                      }
                      @if (selectedDisease == '') {
                        <div>
                          <!-- No Data Available-->
                          <p style="font-size: 11px;"> Please select measure to view details</p>
                        </div>
                      }
                    </div>
                </p-tabpanel>
                <p-tabpanel [value]="items[1].label">
                  <div>
                    <p class="italicText">Note: The list includes Active Patients only.</p>
                    <div class="memberContainer memberView">
                      <div class="searchContainer row">
                        <div class="col-md-12 padLeftRight0">
                          <p class="searchMember">Search Member</p>
                          <div class="form-inline">
                            <input class="form-control mr-1" placeholder="Search any Member" [(ngModel)]="searchInput"
                              (ngModelChange)="filterMember($event)">
                            </div>
                          </div>
                        </div>
                        <table class="table custom-table" id="myTable">
                          <thead>
                            <tr class="table-header">
                              <th>Member ID</th>
                              <th>Member Name</th>
                              <th>Date of birth</th>
                              <th>PCP Name</th>
                              <th class=""></th>
                            </tr>
                          </thead>
                          <tbody class="panel">
                            @for (memId of keys; track memId; let rowIndex = $index) {
                              <tr (click)="toggleRow(rowIndex, memId,qmDataGrpByMember[memId])" [ngClass]="currentOpenRowIndex==rowIndex ?'caremore-bg-tr':''"  data-bs-toggle="collapse" [attr.data-target]="'#demo' + rowIndex"
                                data-bs-parent="#myTable">
                                <td>{{qmDataGrpByMember[memId].memberId }}</td>
                                <td>{{qmDataGrpByMember[memId].membername }}</td>
                                <td>{{qmDataGrpByMember[memId].dob | customDateFilter}}</td>
                                <td>{{qmDataGrpByMember[memId].pcpName }}</td>
                                <td class="emptyTd">
                                  @if (currentOpenRowIndex!==rowIndex) {
                                    <i class="bi bi-chevron-down" style="background-color: transparent;">
                                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16">
                                        <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"/>
                                      </svg>
                                    </i>
                                  }
                                  @if (currentOpenRowIndex==rowIndex) {
                                    <i class="bi bi-chevron-right" style="background-color: transparent;" >
                                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
                                        <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"/>
                                      </svg>
                                    </i>
                                  }
                                </td>
                              </tr>
                              <tr id="{{ 'demo' +  rowIndex }}" class="collapse">
                                <td colspan="6" class="hiddenRow">
                                  <div>
                                    <h3 class="heading heading-format"> Measure Details</h3>
                                    <table class="table custom-table innerTable">
                                      <thead>
                                        <tr class="table-header">
                                          <th>Measure Name</th>
                                          <th>Due date</th>
                                          <th>Event value</th>
                                          <th>Status</th>
                                          <th>Event Notes</th>
                                          <th>Exclusion Notes</th>
                                          <th>Medical Records</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        @for (measure of qmDataGrpByMember[memId].measures; track measure; let i = $index) {
                                          <ng-container
                                            href="javascript:void(0)">
                                            <tr
                                              class="pointer">
                                              <td [ngClass]="{'rowBgchanged':isTableOpen(i)}"  (click)="template1(qmDataGrpByMember[memId]);">{{ measure.measure }}</td>
                                              <td [ngClass]="{'rowBgchanged':isTableOpen(i)}" (click)="template1(qmDataGrpByMember[memId]);">{{ measure.dueDate }}</td>
                                              <td [ngClass]="{'rowBgchanged':isTableOpen(i)}" (click)="template1(qmDataGrpByMember[memId]);">{{ measure.eventValue }}</td>
                                              <td [ngClass]="{'rowBgchanged':isTableOpen(i)}" (click)="template1(qmDataGrpByMember[memId]);">{{ measure.status }}</td>
                                              <td [ngClass]="{'rowBgchanged':isTableOpen(i)}" (click)="template1(qmDataGrpByMember[memId]);">{{ measure.eventNotes }}</td>
                                              <td [ngClass]="{'rowBgchanged':isTableOpen(i)}" (click)="template1(qmDataGrpByMember[memId]);">{{ measure.excludedNote }}</td>
                                              <td [ngClass]="{'rowBgchanged':isTableOpen(i)}">
                                                <div class="documentUploadIcon">
                                                  <span class="documentIcon" [ngClass]="{'ifUploadIconHide': measure?.status === 'MET'}">
                                                    <img src="assets/images/DocumentIcon.svg"  [ngClass]="{'disabled-img': isTableOpen(i)}"   title="Documents" class="logo-docsPdf"   (click)=" showDoc(i,measure,'measure')"/>
                                                  </span>
                                                  @if (measure?.status!='MET' && medDocUploadFlaglist[measure.measureId] == true) {
                                                    <img src="assets/images/upload-docs.svg" class="logo-upload"  title="Upload Document"  (click)="uploadQmeasureMedicalDoc(rowIndex,measure,'measure')"  />
                                                  }
                                                </div>
                                              </td>
                                            </tr>
                                            @if (isTableOpen(i)) {
                                              <tr >
                                                <td colspan="9">
                                                  <div class="uploadedDoc-section">
                                                    <p class="DocumentHeading-section">
                                                      <span>
                                                        Submitted Medical Record Documents
                                                      </span>
                                                      <img src="assets/images/icon_close copy.svg"  title="close" class="close-icon"   (click)=" closeRow()"/>
                                                      <!-- <button class="close-btn" (click)="closeRow()">X</button> -->
                                                    </p>
                                                    <div class="table-body">
                                                      <table style="width: 100% ;border: 1px solid #D1D1D1;">
                                                        <thead>
                                                          <tr>
                                                            <th>Document Name</th>
                                                            <th>Document Type</th>
                                                            <th>Date Uploaded</th>
                                                            <th>Status</th>
                                                            <th style="width:25%">Actions</th>
                                                          </tr>
                                                        </thead>
                                                        <tbody>
                                                          @if (qmUploadedDoc.length === 0) {
                                                            <tr>
                                                              <td colspan="5" style="text-align: center;">
                                                                No document available
                                                              </td>
                                                            </tr>
                                                          }
                                                          @for (each of qmUploadedDoc; track each) {
                                                            <tr style="border: 1px solid #D1D1D1;">
                                                              <td>
                                                                <span>
                                                                  <img src="assets/images/DocumentIcon.svg"  title="pdf-icon" class="pdfTypeIcon"/>
                                                                </span>
                                                                {{each.DocumentTitle}}
                                                              </td>
                                                              <td>
                                                                {{each.type}}
                                                              </td>
                                                              <td>
                                                                {{each.UpdatedDate}}
                                                              </td>
                                                              <td>
                                                                @if (measure?.status=='NOT MET') {
                                                                  <button class="inProgressBtn">
                                                                    In Progress
                                                                  </button>
                                                                  } <br>
                                                                  @if (each?.status=='Rejected') {
                                                                    <button class="declinnedBtn">
                                                                      Rejected
                                                                    </button>
                                                                  }
                                                                  @if (measure?.status=='MET') {
                                                                    <button class="approvedBtn">
                                                                      Approved
                                                                    </button>
                                                                  }
                                                                </td>
                                                                <td>
                                                                  <img src="assets/images/View-Icon.svg"  title="Preview" class="logo-preview"  (click)="onViewDocument(each)"/>
                                                                  <img src="assets/images/DownloadDocs-Icon.svg"  title="Download"  (click)="getDocument(each)" class="logo-download"/>
                                                                  <img src="assets/images/Delete-Icon.svg" title="Delete" (click)="showDeleteModel(each)"  class="logo-delete"/>
                                                                </td>
                                                              </tr>
                                                            }
                                                          </tbody>
                                                        </table>
                                                      </div>
                                                    </div>
                                                  </td>
                                                </tr>
                                              }
                                            </ng-container>
                                          }
                                        </tbody>
                                      </table>
                                    </div>
                                  </td>
                                </tr>
                              }
                            </tbody>
                          </table>
                        </div>
                      </div>
                </p-tabpanel>
              </p-tabpanels>
              </p-tabs>
            <!-- <p-tabMenu [model]="items" [activeItem]="activatedMenu" #menuItems (click)="onActivatedMenu($event)">
            </p-tabMenu>
            <p-tabView (onChange)="onTabChange($event)">
              <button class="reportBtn carelon-btn" (click)="showDialog = !showDialog">Generate HEDIS Report</button>
              @if (activatedMenu?.label === 'Measure View') {
                
            }
            @if (activatedMenu?.label === 'Measure Dashboard') {
             
              }
              @if (activatedMenu?.label === 'Member List View') {
              
                  }
                </p-tabView> -->
                <!-- <div *ngIf="activatedMenu?.label === 'Graph View'">
                <div class="graph-indications">
                  <span class="average item"><span class=color></span>Average</span>
                  <span class="target item"><span class=color></span>Target</span>
                </div>
                <div id="graphDiv"></div>
              </div> -->
            </div>
          }
        </div>

      </div>

    </div>


  </div>
  <app-footer></app-footer>
</div>


<!-- [responsive]="true" -->
<p-dialog header="HEDIS REPORT" [(visible)]="showDialog" modal="modal" class="reports hedisRportSection" >
  <div class="row report-row ">
    <div class="col-md-16">
      <div class="cup-disclaimer">
        <span class="symbol">*</span>
        <span>To download entire list into a report, please click the Generate HEDIS Report button</span>
      </div>
      <form [formGroup]="hedisForm" autocomplete="off" novalidate>
        <div class="row">
          <div class=" form-group col-md-8 col-xs-11 cup-dd-down-arrow cup-dd-down-screen-basis mutliSelectDropdown">
            <label for="memberHealthPlan" class="labelsForHedisReport">Measure Name</label>
            <angular2-multiselect [data]="measureList" [(ngModel)]="selectedProduct" class="multiselect-dropdown-style form-control popup-text"
              [settings]="getSettings('Filter by Measure Name')" formControlName="measure">
            </angular2-multiselect>
          </div>
          <div class="form-group col-md-8 col-xs-11 cup-dd-down-arrow cup-dd-down-arrow-search cup-dd-down-screen-basis">
            <label for="memberHealthPlan" class="labelsForHedisReport"> Measure Status</label>
            <cup-autocomplete class="input-underline" [colWidth]="16"
              [control]="hedisForm.controls.measureStatus" formControlName="measureStatus"
              [autoCompleteModel]="hedisForm.get('measureStatus').value" [autoCompleteDynamic]="true"
              [autoCompleteOptions]="measureStatusList" emptyMessage='No Measures Status Found'
            [autoCompletePlaceholder]="'Filter by Measure Status'"></cup-autocomplete>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-8 col-xs-11 cup-dd-down-arrow cup-dd-down-arrow-search cup-dd-down-screen-basis">
            <label for="memberHealthPlan" class="labelsForHedisReport"> Member Name</label>
            <cup-autocomplete class="input-underline" [colWidth]="16"
              [control]="hedisForm.controls.memberName" formControlName="memberName"
              [autoCompleteModel]="hedisForm.get('memberName').value" [autoCompleteDynamic]="true"
              [autoCompleteOptions]="memberNameList" emptyMessage='No Members Found'
            [autoCompletePlaceholder]="'Filter by Member Name'"></cup-autocomplete>
          </div>
        </div>
        <div class="row">
          <div class="col-md-16 btnsContainerQM m-t-10" style="text-align: center">
            <!--<button class="btn cancel" (click)="cancel();">Cancel</button>-->
            <button class="carelon-btn m-r-10" style="width: 200px" (click)="downloadReport();">Generate HEDIS Report</button>
            <button class="carelon-btn"  (click)="clearHedisReportFilter();"><i class="fa fa-times"></i> Clear</button>
          </div>
        </div>
      </form>
    </div>

  </div>
</p-dialog>

<!-- Multi-Select HEDIS Report Dialog -->
<p-dialog header="GENERATE HEDIS REPORT" [(visible)]="showMultiSelectHedisDialog" [modal]="true" class="reports hedisRportSection" [style]="{width: '50vw'}">
  <div class="row report-row">
    <div class="col-md-16">
      <div class="cup-disclaimer">
        <span class="symbol">*</span>
        <span>Select sites and/or PCPs to generate HEDIS report</span>
      </div>
      <form [formGroup]="multiSelectHedisForm" autocomplete="off" novalidate>
        <div class="row">
          <div class="form-group col-md-16 col-xs-11 cup-dd-down-arrow cup-dd-down-screen-basis mutliSelectDropdown">
            <label for="sites" class="labelsForHedisReport">Sites</label>
            <angular2-multiselect 
              [data]="allSitesForHedis" 
              [(ngModel)]="selectedSitesForHedis" 
              class="multiselect-dropdown-style form-control popup-text"
              [settings]="getSettings('Select Sites')" 
              formControlName="sites"
              (onSelect)="onSiteSelectionChange($event)"
              (onDeSelect)="onSiteSelectionChange($event)"
              (onSelectAll)="onSiteSelectionChange($event)"
              (onDeSelectAll)="onSiteSelectionChange($event)">
            </angular2-multiselect>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-16 col-xs-11 cup-dd-down-arrow cup-dd-down-screen-basis mutliSelectDropdown">
            <label for="pcps" class="labelsForHedisReport">Primary Care Physicians</label>
            <angular2-multiselect 
              [data]="allPcpsForHedis" 
              [(ngModel)]="selectedPcpsForHedis" 
              class="multiselect-dropdown-style form-control popup-text"
              [settings]="getSettings('Select PCPs')" 
              formControlName="pcps"
              (onSelect)="onPcpSelectionChange($event)"
              (onDeSelect)="onPcpSelectionChange($event)"
              (onSelectAll)="onPcpSelectionChange($event)"
              (onDeSelectAll)="onPcpSelectionChange($event)">
            </angular2-multiselect>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-16 col-xs-11 cup-dd-down-arrow cup-dd-down-arrow-search cup-dd-down-screen-basis">
            <label for="status" class="labelsForHedisReport">Status</label>
            <cup-autocomplete class="input-underline" [colWidth]="16"
              [control]="multiSelectHedisForm.controls.status" formControlName="status"
              [autoCompleteModel]="multiSelectHedisForm.get('status').value" [autoCompleteDynamic]="true"
              [autoCompleteOptions]="statusFilterList" emptyMessage='No Status Found'
              [autoCompletePlaceholder]="'Filter by Status (Met/Not Met)'"></cup-autocomplete>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-16 col-xs-11 cup-dd-down-arrow cup-dd-down-screen-basis mutliSelectDropdown">
            <label for="measures" class="labelsForHedisReport">Measure Name</label>
            <angular2-multiselect 
              [data]="allMeasuresForHedis" 
              [(ngModel)]="selectedMeasuresForHedis" 
              class="multiselect-dropdown-style form-control popup-text"
              [settings]="getSettings('Select Measures')" 
              formControlName="measures">
            </angular2-multiselect>
          </div>
        </div>
        <div class="row">
          <div class="col-md-16 btnsContainerQM m-t-10" style="text-align: center">
            <button class="carelon-btn m-r-10" style="width: 200px" [disabled]="isMultiSelectHedisReportDisabled" (click)="generateMultiSelectHedisReport();">Generate Report</button>
            <button class="carelon-btn" (click)="closeMultiSelectHedisDialog();"><i class="fa fa-times"></i> Cancel</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</p-dialog>

<!-- [responsive]="true" -->
<p-dialog header="PROVIDER SEARCH" [modal]="true" width="500"
  class="member-pcp-modal">
  @if (showLookUp) {
    <div id="general-auth-search-dialog"
      class="dialog-content general-auth-search-dialog provider-dialog">
      <span class="note-provider-not-find">
        <span class="note-span">*</span> NOTE: If you cannot find the provider, use the provider name "PROVIDER CAN'T
        FIND".
      </span>
      <app-providersearchpanel [clearBtnView]='1' [maintainSearchState]='false'></app-providersearchpanel>
      <span class="note-approximate-zipcode zipcode-text">
        <span class="note-span search-disclaim">*</span> NOTE: Miles displayed are approximated between Zip Codes
      </span>
      <app-providersearch (sendProviderDetails)="sendProviderDetails($event)" [showProvider]="showProvider">
      </app-providersearch>
    </div>
  }
</p-dialog>



<div class="modal fade" id="errorMessageModal" role="dialog">
  <div class="modal-dialog" style="margin-top: 10%;">
    <div class="modal-content" style="width: 106%;">
      <div class="modal-header" style="border-bottom: 0px;">
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>
      <div class="modal-body">
        <!-- <p class="text-center" style="font-weight: bold;font-size:16px;">Login failed</p> -->
        <p>Your access permissions restrict viewing this information.  If this is an error, please contact your
        office administrator or Provider Relations at 888-291-1358 option 3 then option 5.</p>
        <br>
          <button type="button" class="contact100-form-btn center-block" data-dismiss="modal">Close</button>
        </div>

        <div class="modal-footer">
          <button type="button"class="btn carelon-btn buttonInfo" data-bs-dismiss="modal">Ok</button>


        </div>

      </div>
    </div>
  </div>

  <!--  upload quality measure document section -->
  <div class="modal  fade qm-doc-upload-model" id="uploadQmDocModal" tabindex="-1" aria-labelledby="uploadQmDocModalLabel" aria-hidden="true"  style="opacity: 1">
    <div class="modal-dialog modal-lg">

      <div class="modal-content">
        <div class="modal-header">
          <h3>Upload Medical Records</h3>
          <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="onCloseModal()"  aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <p>Please select any of the following methods to upload the Medical Record Documents!</p>

          <div class=" doccontainer attachment padMargin0" style="margin-top:5px">
            <form [formGroup]="uploadFile">
              <input type="file" accept=".doc,.docx , .pdf,  .xls, .xlsx, .ppt, .pptx, .jpg, .jpeg, .png" #inputFile (change)="selectedFile($event,inputFile)" formControlname="file"/>
            </form>
            <div class="" style="padding-bottom: 8px;">
              <img src="assets/images/upload.svg" class="logo" />
            </div>
            <div class="">
              <span>Drag and drop a file here or click the Browse file to choose a record!</span>
            </div>
            <div class=" supporType">
              <span> Supported File Formats: Word (.doc, .docx), Excel (.xls, .xlsx), Picture (.jpg, .jpeg, .png ) and .PDF  </span>
            </div>
            <div class="">
              <button class="btn-browseFile" (click)="inputFile.click()" type="button">Browse File</button>
            </div>
          </div>
          <!-- <div class="maxFileSize">
          <p>Maximum file size : 2MB</p>
        </div> -->
        @if (lengthOfDocuments) {
          <div class="Error-docLemitCross">
            <img src="assets/images/error.svg" alt="">
            <p>
              Not more than 10 files can be uploaded!
            </p>
          </div>
        }
        @if (isInvalidFileType) {
          <div class="Error-docLemitCross" >
            <img src="assets/images/error.svg" alt="">
            <p>
              The file format is not valid. Please choose a file with valid format.
            </p>
          </div>
        }
        <div class="selectedFilesSection">
          <ul class="p-0">
            @for (file of selectedFiles; track file) {
              <li>
                @if (file?.fileType == 'pdf') {
                  <span>
                    <i
                      class="fa fa-file-pdf-o doc-icon"
                    ></i>
                  </span>
                }
                @if (
                  file?.fileType == 'docx' ) {
                  <span
                    >
                    <i
                      class="fa fa-file-word-o doc-iconword"
                    ></i>
                  </span>
                }
                <span class="selectedfilesList">
                  {{ file.name }}
                  <span>
                    <img src="assets/images/icon_close copy.svg"  title="close" class="removeFile" (click)="removeFile(file)"/>
                  </span>
                </span>
              </li>
            }
          </ul>

        </div>

      </div>
      <div class="modal-footer">
        <div class="btn-section">
          <button class="btn-browseFile" type="button" (click)="onCloseModal()"  data-bs-dismiss="modal">Close</button>
          <button class="carelon-btn"  [ngStyle]="{'opacity': lengthOfDocuments || selectedFiles.length==0 ? 0.5 : 1}"   (click)="uploadQmDocs()"  [disabled]="lengthOfDocuments || selectedFiles.length==0">Upload</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade qm-doc-upload-model" data-bs-keyboard="false" data-bs-backdrop="true" id="deleteModal" role="dialog" style="opacity: 1">
  <div class="modal-dialog qm-doc-delete-model">
    <div class="modal-content">
      <div class="modal-header">
        <h3 style="color: #23499E;font-size: 20px;font-weight: bold;">Delete Document</h3>
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>
      <div class="modal-body">
        <p>Do you really want to delete the file?</p>
      </div>
      <div class="modal-footer">
        <div>
          <button type="button"class="btn carelon-btn buttonInfo" data-bs-dismiss="modal" style="margin-right: 4px !important;" (click)="deleteUploadedDoc()">Yes</button>
          <button type="button"class="btn carelon-btn buttonInfo" data-bs-dismiss="modal">No</button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- successfull upload document modal -->
<div class="modal fade qm-doc-upload-model" data-keyboard="false" data-backdrop="static" id="docUploadedSuccessModal" role="dialog" style="opacity: 1">
  <div class="modal-dialog qm-doc-delete-model">
    <div class="modal-content">
      <div class="modal-header" style="background-color:white">
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>
      <div class="modal-body uploaded-success-body">
        <div class="row">
          <div class="col-md-12">
            <div class="success-img">
              <i class="bi bi-check-circle">
                <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" fill="currentColor" class="bi bi-check-circle" viewBox="0 0 16 16">
                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                  <path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05"/>
                </svg>
              </i>
            </div>
          </div>
          <div class="col-md-12 mt-5">
            <p>Documents uploaded successfully!</p>
          </div>
        </div>


      </div>
      <div class="modal-footer d-flex justify-content-center">
        <div >
          <button type="button"class="btn carelon-btn buttonInfo" data-bs-dismiss="modal">Ok</button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- error handling if uplaod doc API got fail -->

<div class="modal fade qm-doc-upload-model" data-keyboard="false" data-backdrop="static" id="docUploadedErrorModal" role="dialog" style="opacity: 1">
  <div class="modal-dialog qm-doc-delete-model">
    <div class="modal-content">
      <div class="modal-header" style="background-color:white">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <h4 style="color: #23499E;font-size: 20px;font-weight: bold;">Error</h4>
      </div>
      <div class="modal-body">
        <p>Document upload failed. Please try again later.</p>
      </div>
      <div class="modal-footer">
        <div>
          <button type="button"class="btn carelon-btn buttonInfo" data-dismiss="modal">Ok</button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- error handling if delete doc API got fail -->
<div class="modal fade qm-doc-upload-model" data-keyboard="false" data-backdrop="static" id="docDeleteErrorModal" role="dialog" style="opacity: 1">
  <div class="modal-dialog qm-doc-delete-model">
    <div class="modal-content">
      <div class="modal-header" style="background-color:white">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <h4 style="color: #23499E;font-size: 20px;font-weight: bold;">Error</h4>
      </div>
      <div class="modal-body">
        <p>Document deletion failed. Please try again later.</p>
      </div>
      <div class="modal-footer">
        <div>
          <button type="button"class="btn carelon-btn buttonInfo" data-dismiss="modal">Ok</button>
        </div>
      </div>
    </div>
  </div>
</div>



<!-- error handling if ListAPI got fail -->

<div class="modal fade qm-doc-upload-model" data-keyboard="false" data-backdrop="static" id="docListUpdateErrorModal" role="dialog" style="opacity: 1">
  <div class="modal-dialog qm-doc-delete-model">
    <div class="modal-content">
      <div class="modal-header" style="margin: 0px;">
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>

      </div>
      <div class="modal-body-error">
        <p class="p1">   <img style="width: 10%;" src="../../../assets/images/icons/Error.svg" alt="Error"></p>
        <p class="p2">An Unexpected error occurred on the server Please try again later. If the error continues, please contact our Provider Relations team at
          <span> providerrelations&#64;caremore.com .</span>
        </p>
      </div>
      <div class="modal-footer d-flex justify-content-center">
        <div>
          <button type="button"class="btn carelon-btn buttonInfo" data-bs-dismiss="modal">Ok</button>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- CUP JWT error notication modal -->
<div class="modal" id="CupJwtErrMsg">
  <div class="modal-dialog modal-dialog-centered ">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="check-circle-err-icon" style="text-align:center">
          <i style="color: #23499E;" class="bi bi-exclamation-circle">
            <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" fill="currentColor" class="bi bi-exclamation-circle"
              viewBox="0 0 16 16">
              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
              <path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0M7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0z" />
            </svg>
          </i>
        </div>
        <div class="modal-body-content">
          <div class="d-flex justify-content-center">
            <h3 style="color: #23499E;">Session Expired</h3>
          </div>
          <div class="d-flex justify-content-center text-center">

          </div>
        </div>
      </div>
      <div class="modal-footer d-flex justify-content-center">
        <button type="button" class="btn closeBtn" (click)="onCloseSessionOut('CupJwtErrMsg')" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<!-- Alert Modal -->
<div class="modal fade" id="alertModal" role="dialog">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Alert</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p>{{ message }}</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn carelon-btn" data-bs-dismiss="modal">Ok</button>
      </div>
    </div>
  </div>
</div>

</div>
